module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.d18011af.svg";